import { useState, useContext, useEffect } from "react"
import { Field, useFormikContext } from "formik"
import { gql, useLazyQuery } from "@apollo/client"
import _ from "lodash"

import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"
import { Dropdown } from "primereact/dropdown"

import styles from "../../../styles/Form.module.css"

export default function TypeYesOrNo({ field, block, index }) {
  const userCtx = useContext(UserContext)
  const form = useContext(FormContext)
  const formik = useFormikContext()
  const [visibility, setVisibility] = useState("none")
  const yesOrNo = [
    {
      label: "No",
      value: "No",
    },
    {
      label: "Yes",
      value: "Yes",
    },
  ]
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  const IS_ACTIVE_TELERECOVERY = gql`
    query isActiveTelerecovery($staff_id: ID!, $organization_id: ID!) {
      service: isMicroservicesActive(
        staff_id: $staff_id
        organization_id: $organization_id
        microservice_name: "Telerecovery"
      ) {
        organization_id
        microservices_id
        microservices_enabled
      }
    }
  `

  const [isActiveTelerecovery] = useLazyQuery(IS_ACTIVE_TELERECOVERY)

  useEffect(() => {
    const getVisibility = async () => {
      await isActiveTelerecovery({
        variables: {
          staff_id: userCtx.session.user.staff_id,
          organization_id: userCtx.current_organization_id,
        },
        fetchPolicy: "no-cache",
        onCompleted: ({ service }) => {
          service?.microservices_enabled === "1"
            ? setVisibility("block")
            : setVisibility("none")
        },
      })
    }

    const value = formik?.getFieldProps(field.field_name)
    if (value.value === "") {
      formik.setFieldValue(field.field_name, "No")
    }

    getVisibility()
  }, [])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visibility,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && "*"}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => (
          <>
            <Dropdown
              placeholder="Please select"
              name={formikField.name}
              value={formikField.value}
              onChange={formikField.onChange}
              disabled={isDisabled}
              options={yesOrNo}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
